import { Oauth2Scheme } from '~auth/runtime'
import Vue from 'vue'

export default class CustomOauth2Scheme extends Oauth2Scheme {
  // Override `fetchUser` method
  async fetchUser(endpoint) {
    // Token is required but not available
    if (!this.check().valid) {
      return
    }

    // User endpoint is disabled.
    if (!this.options.endpoints.userInfo) {
      this.$auth.setUser({})
      return
    }

    // Try to fetch user and then set
    return this.$auth.requestWith(
      this.name,
      endpoint,
      this.options.endpoints.userInfo
    ).then((response) => {
      const user = response.data

      // Transform the user object
      const customUser = {
        ...user,
        roles: ['user'] // Добавление кастомных полей, если необходимо
      }
      this.$auth.setUser(customUser)

      return response
    }).catch((error) => {
      if (error.response && error.response.status && error.response.status === 401) {
        if (error.response.data?.detail === 'USER_DISABLED_ERROR') {
          Vue.prototype.$warning({
            title: 'Ваш аккаунт временно заблокирован',
            content: 'За уточнением напишите нам по адресу vs@vistat.org'
          })
        } else {
          Vue.prototype.$message.error('Не получилось авторизоваться')
        }
      }

      this.$auth.callOnError(error, { method: 'fetchUser' })
    })
  }
}
